import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DashboardCard from "../../pages/home/common/DashboardCard";
import { getCardLabel } from "./TMEPlaceholders";
import CalendarLoader from "../common-components/CalendarLoader";

const TMEStats = ({
  activeCardIndex,
  setActiveCardIndex,
  tableRef,
  mobileTableRef,
  selectedTab,
}) => {
  const {
    tmeStatsLoading,
    tmeStats,
    tmeStatsError,
    tmeActiveUserStatsLoading,
    tmeActiveUserStats,
    tmeActiveUserStatsError,
    tmeExpiredMembersStatsLoading,
    tmeExpiredMembersStats,
    tmeExpiredMembersStatsError,
  } = useSelector((state) => state.api);

  const [allStatsData, setAllStatsData] = useState({});
  const [allStatsDataV1, setAllStatsDataV1] = useState({});
  const [allExpiredMembersStatsData, setAllExpiredMembersStatsData] = useState(
    {}
  );

  // const EXCLUDED_KEYS = [""];
  const EXCLUDED_KEYS = ["total_trainers", "expired_member_mapped_trainer"];

  const handleCardClick = (_, index) => {
    setActiveCardIndex((prevIndex) => (prevIndex === index ? null : index));

    tableRef?.current?.scrollIntoView({ behavior: "smooth" });
    mobileTableRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (
      tmeStats?.status &&
      tmeStats?.data &&
      !tmeStatsLoading &&
      !tmeStatsError
    ) {
      setAllStatsData(tmeStats.data[0]);
    } else {
      setAllStatsData({});
    }
  }, [tmeStatsLoading, tmeStatsLoading, tmeStatsError]);

  useEffect(() => {
    if (
      !tmeActiveUserStatsLoading &&
      !tmeActiveUserStatsError &&
      tmeActiveUserStats?.status &&
      tmeActiveUserStats?.data
    ) {
      setAllStatsDataV1(tmeActiveUserStats.data);
    } else {
      setAllStatsDataV1({});
    }
  }, [tmeActiveUserStatsLoading, tmeActiveUserStats, tmeActiveUserStatsError]);

  useEffect(() => {
    if (
      !tmeExpiredMembersStatsLoading &&
      !tmeExpiredMembersStatsError &&
      tmeExpiredMembersStats?.status &&
      tmeExpiredMembersStats?.data
    ) {
      setAllExpiredMembersStatsData(tmeExpiredMembersStats.data);
    } else {
      setAllExpiredMembersStatsData({});
    }
  }, [
    tmeExpiredMembersStatsLoading,
    tmeExpiredMembersStats,
    tmeExpiredMembersStatsError,
  ]);

  return (
    <>
      {selectedTab === 0 && (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {tmeStatsLoading ? (
            <CalendarLoader daysCount={4} />
          ) : (
            Object.entries(allStatsData).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {!EXCLUDED_KEYS.includes(key) && (
                    <DashboardCard
                      tagName="tme"
                      filterType={key}
                      cardLabel={getCardLabel(key)}
                      value={value || 0}
                      onClickCard={handleCardClick}
                      cardIndex={index}
                      isActiveCard={activeCardIndex === key}
                      isCardClickable={true}
                    />
                  )}
                </React.Fragment>
              );
            })
          )}
        </div>
      )}

      {selectedTab === 2 && (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {tmeActiveUserStatsLoading ? (
            <CalendarLoader daysCount={4} />
          ) : (
            allStatsDataV1 &&
            Object.entries(allStatsDataV1).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {!EXCLUDED_KEYS.includes(key) && (
                    <DashboardCard
                      tagName="tme"
                      filterType={key}
                      cardLabel={getCardLabel(key)}
                      value={value || 0}
                      onClickCard={handleCardClick}
                      cardIndex={index}
                      isActiveCard={activeCardIndex === key}
                      isCardClickable={
                        key === "total_trainers" ||
                        key === "expired_member_mapped_trainer"
                          ? false
                          : true
                      }
                    />
                  )}
                </React.Fragment>
              );
            })
          )}
        </div>
      )}

      {selectedTab === 3 && (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {tmeExpiredMembersStatsLoading ? (
            <CalendarLoader daysCount={4} />
          ) : (
            allExpiredMembersStatsData &&
            Object.entries(allExpiredMembersStatsData).map(
              ([key, value], index) => {
                return (
                  <React.Fragment key={index}>
                    {!EXCLUDED_KEYS.includes(key) && (
                      <DashboardCard
                        tagName="tme"
                        filterType={key}
                        cardLabel={getCardLabel(key)}
                        value={value || 0}
                        onClickCard={handleCardClick}
                        cardIndex={index}
                        isActiveCard={activeCardIndex === key}
                        isCardClickable={
                          key === "total_trainers" ||
                          key === "expired_member_mapped_trainer"
                            ? false
                            : true
                        }
                      />
                    )}
                  </React.Fragment>
                );
              }
            )
          )}
        </div>
      )}
    </>
  );
};

export default TMEStats;
